import { IS_INTRO_SEEN_KEY } from "../spa/constants";

const htmlEl = document.querySelector('body');

const isIOS = () => {
	return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};
const isAndroid = () => {
	return /Android/i.test(navigator.userAgent);
};

window.timers = [];

export default {
	isIOS,
	isAndroid,
	timeFormat: (seconds) => {
		const intSec = Math.floor(seconds);
		const secs = intSec % 60;
		const mins = Math.floor(intSec / 60);
		return `${mins}:${(secs < 10 ? `0${secs}` : secs)}`;
	},
	progress: (totalTime, currentTime) => {
		return Math.round((totalTime > 0 ? currentTime / totalTime : 0) * 100);
	},
	angle: (totalTime, currentTime) => {
		return (totalTime > 0 ? currentTime / totalTime : 0) * 360;
	},
	pauseScrolling: (ms, callback = false) => {
		console.info(`Pause: ${ms}ms`)
		htmlEl.style.overflow = 'hidden';
		if (isIOS()) {
			htmlEl.style.touchAction = 'none';
		}
		const timeoutId = setTimeout(() => {
			htmlEl.style.overflow = 'scroll';
			if (isIOS()) {
				htmlEl.style.touchAction = 'auto';
			}
			console.log('release scroll');
			if (callback !== false) {
				callback();
			}
		}, ms);
		window.timers.push(timeoutId);
	},
	disableScrolling: () => {
		htmlEl.style.overflow = 'hidden';
		if (isIOS()) {
			htmlEl.style.touchAction = 'none';
			document.querySelector('html').style.touchAction = 'none';
		}
		// console.log('disable scrolling')
	},
	enableScrolling: (arg) => {
		htmlEl.style.overflow = 'scroll';
		if (isIOS()) {
			htmlEl.style.touchAction = 'auto';
			document.querySelector('html').style.touchAction = 'none';
		}
	},
	isIntroSeen: () => {
		return localStorage.getItem(IS_INTRO_SEEN_KEY) == 'yes';
	},
	setIntroSeen: () => {
		localStorage.setItem(IS_INTRO_SEEN_KEY, 'yes');
	},
	setIntroUnseen: () => {
		localStorage.setItem(IS_INTRO_SEEN_KEY, 'no');
	},
	getRandomIntInclusive: (min, max) => {
		min = Math.ceil(min);
		max = Math.floor(max);
		return Math.floor(Math.random() * (max - min + 1) + min);
	},
	getCurrentPhotoGallerySet: () => {
		return window.photoGallery;
		// return JSON.parse(localStorage.getItem('photoGallery'));
	},
	setCurrentPhotoGallerySet: data => {
		window.photoGallery = data;
		// localStorage.setItem('photoGallery', JSON.stringify(data));
	},
}
